import { Button } from "@wags/ui/button.tsx";
import {
    MobileFloatingAction,
    FLOATING_ACTION_CLASS,
} from "@wags/ui/mobile-floating-action.tsx";
import type { ReactNode } from "react";
import { ADOPTION_STATUS_LABEL } from "@/features/listings";
import type {
    DockPresentation,
    HeaderAction,
} from "./dog-listing-presentation";

export type PrimaryAction = {
    label: string;
    compactLabel: string;
    accessibleLabel: string;
    onClick: () => void;
};

export function HeaderListingAction({
    action,
    priceDisplay,
    primaryAction,
    contact,
    draftActions,
}: {
    action: HeaderAction;
    priceDisplay: string | null;
    primaryAction: PrimaryAction;
    contact: PrimaryAction | null;
    draftActions: ReactNode;
}) {
    if (action === "status-contact") {
        return contact ? (
            <Button
                type="button"
                aria-label={contact.accessibleLabel}
                emphasis="cta"
                size="lg"
                onClick={contact.onClick}
            >
                {contact.compactLabel}
            </Button>
        ) : null;
    }
    if (action === "status-label") {
        return (
            <p className="text-body-small font-medium text-doberman-black/60">
                {ADOPTION_STATUS_LABEL.pending}
            </p>
        );
    }
    return (
        <>
            {priceDisplay && (
                <p className="text-body font-semibold text-doberman-black">
                    {priceDisplay}
                </p>
            )}
            {action === "draft" ? (
                draftActions
            ) : (
                <Button
                    type="button"
                    aria-label={primaryAction.accessibleLabel}
                    emphasis="cta"
                    size="lg"
                    onClick={primaryAction.onClick}
                >
                    {primaryAction.compactLabel}
                </Button>
            )}
        </>
    );
}

export function FloatingListingAction({
    action,
    primaryAction,
    contact,
}: {
    action: DockPresentation["floating"];
    primaryAction: PrimaryAction;
    contact: PrimaryAction | null;
}) {
    const button = action === "buy" ? primaryAction : action && contact;
    if (!button) return null;
    return (
        <MobileFloatingAction
            className="md:block dog-desktop:hidden"
            style={{ WebkitTouchCallout: "none" }}
        >
            <Button
                type="button"
                aria-label={button.accessibleLabel}
                className={FLOATING_ACTION_CLASS}
                onClick={button.onClick}
            >
                {button.compactLabel}
            </Button>
        </MobileFloatingAction>
    );
}
